export default __webpack_public_path__ + "static/media/img-0510-croatia-full-face.8e04c8aa.png";